import { Tabs } from "@package/subframe/components/Tabs";
import {
  createFileRoute,
  Link,
  Outlet,
  useLocation,
} from "@tanstack/react-router";

import { useAuth } from "@/contexts/AuthContext";

export const Route = createFileRoute("/_authenticated/organisations/$slug")({
  component: OrganisationLayout,
});

function OrganisationLayout() {
  const { slug } = Route.useParams();
  const { isPlatformAdmin, memberships } = useAuth();
  const location = useLocation();
  const pathname = location.pathname;

  // Org admins (and platform admins) can configure org-level policy (NAU-220).
  // Only an ACTIVE admin membership counts (mirrors OrganisationContext).
  const isOrgAdmin = memberships.some(
    (m) => m.role === "ADMIN" && m.status === "ACTIVE",
  );
  const canConfigure = isPlatformAdmin || isOrgAdmin;

  // Determine active tab based on pathname
  const getActiveTab = () => {
    if (pathname.includes("/members")) return "members";
    if (pathname.includes("/templates")) return "templates";
    if (pathname.includes("/branches")) return "branches";
    if (pathname.includes("/configure")) return "configure";
    return "details";
  };

  const activeTab = getActiveTab();

  return (
    <div className="w-full">
      <Tabs>
        <Link to="/organisations/$slug" params={{ slug }}>
          <Tabs.Item active={activeTab === "details"}>Details</Tabs.Item>
        </Link>
        {isPlatformAdmin && (
          <Link to="/organisations/$slug/templates" params={{ slug }}>
            <Tabs.Item active={activeTab === "templates"}>Templates</Tabs.Item>
          </Link>
        )}
        {isPlatformAdmin && (
          <Link to="/organisations/$slug/members" params={{ slug }}>
            <Tabs.Item active={activeTab === "members"}>Members</Tabs.Item>
          </Link>
        )}
        <Link to="/organisations/$slug/branches" params={{ slug }}>
          <Tabs.Item active={activeTab === "branches"}>Nurseries</Tabs.Item>
        </Link>
        {canConfigure && (
          <Link to="/organisations/$slug/configure" params={{ slug }}>
            <Tabs.Item active={activeTab === "configure"}>Configure</Tabs.Item>
          </Link>
        )}
      </Tabs>
      <div className="mt-4">
        <Outlet />
      </div>
    </div>
  );
}
